<template>
  <div
    class="payment-item"
    @click="to">
    <section>
      <div class="d-flex align-items-center p-3">
        <div class="payment-item__icon">
          <picture class="img-fluid">
            <source
              srcset="@/assets/film-icon.webp"
              type="image/webp">
            <source
              srcset="@/assets/film-icon.png"
              type="image/png">
            <img
              src="@/assets/film-icon.png"
              alt=""
              width="96"
              height="78"
              class="img-fluid">
          </picture>
        </div>
        <div
          :class="{'px-3': true,
                   'payment-item__content': !disabled,
                   'my-payment-item__content': disabled }">
          <p class="my-0 text-truncate">检查部位：{{ data.patient_info.check_item }}</p>
          <p class="my-0 text-truncate">检查编号：{{ data.image_id }}</p>
          <p class="my-0 text-truncate">检查时间：{{ data.patient_info.check_time }}</p>
        </div>
        <div
          v-if="!disabled"
          class="text-warning text-right payment-item__price">
          {{ data.current_price|currency }}
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import accounting from 'accounting';

export default {
  name: 'OrderDetailItem',
  filters: {
    currency(value) {
      return accounting.formatMoney(value / 100, '￥', 2, ',', '.');
    },
  },
  props: {
    data: {
      type: Object,
      required: true,
      default() {
        return {
          image_id: '',
          patient_info: {
            check_item: '',
            check_time: '',
            hospital_id_ykb: '',
          },
        };
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    to() {
      if (this.disabled) {
        return;
      }
      this.$router.push({
        name: 'report-detail',
        params: { id: this.data.image_id },
        query: {
          hospitalId: this.data.patient_info.hospital_id_ykb,
        },
      });
    },
  },
};
</script>

<style scoped>
.payment-item {
  background-color: #fff;
  color: #000;
  display: block;
}

.payment-item::after {
  content: ' ';
  display: block;
  margin-left: 1rem;
  height: 1px;
  background-color: #eee;
}

.payment-item:last-child::after {
  margin-left: 0;
}

.payment-item__icon {
  width: 48px;
}

.payment-item__price {
  width: 5rem;
}

.payment-item__content {
  flex: 1;
  max-width: calc(100% - 160px);
}

.my-payment-item__content {
  flex: 1;
}
</style>
